import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { CustomImageModal, customSortByKey, DateRangePicker, handleErrorToast } from "../CustomFunctions";
import { CSSForFilterDropdown, CSSForDropdownFilter, CSSForDropdownFilter2 } from "../CustomUtilities";
import Select from "react-select";
import { AddwithWhiteCircle, SearchBig, Employee, UpdatePencil, CircularGrid, Active } from "../AllSvg";
import { formatDate, formattedDateLong } from "../Date";
import UserDefaultLogo from "./UserDefaultLogo";
import usePermission from "../../config/permissions";

const AssetModel = ({ getAsset, employeeList }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    emp_code: "",
    date: "",
    description: "",
    quantity: "",
    item: "",
    sub_company: sessionStorage.getItem('company_id')
  });

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "emp_code",
      "date",
      "description",
      "quantity",
      "item",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: value,
      };

      if (name === "emp_code") {
        const selectedEmployee = employeeList.find(emp => emp.emp_code === value);
        if (selectedEmployee) {
          updatedFormData.name = selectedEmployee.name;
        } else {
          updatedFormData.name = "";
        }
      }

      return updatedFormData;
    });
  };

  //******************Valedation End*********************** */

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/assets/`, formData);

        if (res.status === 200) {
          await getAsset();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className="upload-svg" onClick={handleShow}>
        <AddwithWhiteCircle />{" "}Asset
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Add Asset Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column form-group-selectt">
                <label htmlFor="emp_code" className="form-labels  font-weight500    font-size-subheading">
                  Employee<span className="required">*</span>
                </label>
                <br />
                <select
                  id="emp_code"
                  name="emp_code"
                  value={formData.emp_code}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.emp_code ? "error" : inputState.emp_code ? "success" : ""
                    }`}
                >
                  <option value="">Select Employee</option>
                  {employeeList.map((i) => (<>
                    <option value={i.emp_code}>{i.emp_code}-{i.name}</option>
                    {/* <option value={i.emp_code}>{i.emp_code}</option> */}
                  </>))
                  }
                </select>
                <div className="form-group-selection-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="25"
                    fill="currentColor"
                    class="bi bi-caret-down-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </div>
                <div>
                  {errors.emp_code && (
                    <span className="error-message font-size-text ">{errors.emp_code}</span>
                  )}
                </div>
              </div>

              <div className="flex-column">
                <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
                  Date<span className="required">*</span>
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  placeholder="Date"
                  onChange={handleInputChange}
                  value={formData.date}
                  className={`form-input ${errors.date ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.date && (
                  <span className="error-message font-size-text ">{errors.date}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="item" className="form-labels  font-weight500    font-size-subheading">
                  Item<span className="required">*</span>
                </label>
                <input
                  type="item"
                  id="item"
                  name="item"
                  placeholder="Name of the item"
                  onChange={handleInputChange}
                  value={formData.item}
                  className={`form-input ${errors.item ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.item && (
                  <span className="error-message font-size-text ">{errors.item}</span>
                )}
              </div>


              <div className="flex-column">
                <label htmlFor="description" className="form-labels  font-weight500    font-size-subheading">
                  Description<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="description"
                  name="description"
                  placeholder="Detail of the Item"
                  onChange={handleInputChange}
                  value={formData.description}
                  className={`form-input ${errors.description
                    ? "error"
                    : inputState.tile
                      ? "success"
                      : ""
                    }`}
                />
                {errors.description && (
                  <span className="error-message font-size-text ">{errors.description}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="quantity" className="form-labels  font-weight500    font-size-subheading">
                  Quantity<span className="required">*</span>
                </label>
                <input
                  type="number"
                  min={0}
                  id="quantity"
                  name="quantity"
                  placeholder="Quantity"
                  onChange={handleInputChange}
                  value={formData.quantity}
                  className={`form-input ${errors.quantity ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.quantity && (
                  <span className="error-message font-size-text ">{errors.quantity}</span>
                )}
              </div>


              <div className="button-models">
                <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button model-button-leave font-weight500  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const AssetModelUpdate = ({ i, getAsset, emp_code, employeeList }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    emp_code: "",
    date: "",
    description: "",
    quantity: "",
    item: "",
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  //******************Valedation Start********************* */

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "emp_code",
      "date",
      "description",
      "quantity",
      "item",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: value,
      };

      if (name === "emp_code") {
        const selectedEmployee = employeeList.find(emp => emp.emp_code === value);
        if (selectedEmployee) {
          updatedFormData.name = selectedEmployee.name;
        } else {
          updatedFormData.name = "";
        }
      }

      return updatedFormData;
    });
  };

  //******************Valedation End*********************** */

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(`${BASE_URL}/wfm/assets/${i.id}/`, formData);

        if (res.status === 200) {
          await getAsset();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err)
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className="model-edit-button-ml" onClick={handleShow}>
        <UpdatePencil />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Update Asset Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
              <div className="flex-column form-group-selectt">
                <label htmlFor="emp_code" className="form-labels  font-weight500    font-size-subheading">
                  Employee<span className="required">*</span>
                </label>
                <br />
                <select
                  id="emp_code"
                  name="emp_code"
                  value={formData.emp_code}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.emp_code ? "error" : inputState.emp_code ? "success" : ""
                    }`}
                >
                  <option value="">Select Employee</option>
                  {employeeList.map((i) => (<>
                    <option value={i.emp_code}>{i.emp_code}-{i.name}</option>
                  </>))
                  }
                </select>
                <div className="form-group-selection-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="25"
                    fill="currentColor"
                    class="bi bi-caret-down-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </div>
                <div>
                  {errors.emp_code && (
                    <span className="error-message font-size-text ">{errors.emp_code}</span>
                  )}
                </div>
              </div>

              <div className="flex-column">
                <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
                  Date<span className="required">*</span>
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  placeholder="Date"
                  onChange={handleInputChange}
                  value={formData.date}
                  className={`form-input ${errors.date ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.date && (
                  <span className="error-message font-size-text ">{errors.date}</span>
                )}
              </div>


              <div className="flex-column">
                <label htmlFor="item" className="form-labels  font-weight500    font-size-subheading">
                  Item<span className="required">*</span>
                </label>
                <input
                  type="item"
                  id="item"
                  name="item"
                  placeholder="Name of the item"
                  onChange={handleInputChange}
                  value={formData.item}
                  className={`form-input ${errors.item ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.item && (
                  <span className="error-message font-size-text ">{errors.item}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="description" className="form-labels  font-weight500    font-size-subheading">
                  Description<span className="required">*</span>
                </label>
                <input
                  type="description"
                  id="description"
                  name="description"
                  placeholder="Detail of the Item"
                  onChange={handleInputChange}
                  value={formData.description}
                  className={`form-input ${errors.description
                    ? "error"
                    : inputState.tile
                      ? "success"
                      : ""
                    }`}
                />
                {errors.description && (
                  <span className="error-message font-size-text ">{errors.description}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="quantity" className="form-labels  font-weight500    font-size-subheading">
                  Quantity<span className="required">*</span>
                </label>
                <input
                  type="number"
                  min={0}
                  id="quantity"
                  name="quantity"
                  placeholder="Quantity"
                  onChange={handleInputChange}
                  value={formData.quantity}
                  className={`form-input ${errors.quantity ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.quantity && (
                  <span className="error-message font-size-text ">{errors.quantity}</span>
                )}
              </div>



              <div className="button-models">
                <button className="model-button   font-weight500   " onClick={handleClose}>
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const AssetModelDelete = ({ i, getAsset }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/wfm/assets/${i.id}/`);

      if (res.status === 200) {
        await getAsset();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err, loadingToastId)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Delete Asset Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

          <div className="parent-div">
            Are You Sure You Want to delete
            <br />Asset detail of : {i.item}
            <br />given to : {i.emp_code}-{i.name}
            <div className="button-models">
              <button className="model-button   font-weight500    " onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const AssetsManagement = ({ emp_code }) => {

  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [assetname, setAssetname] = useState([]);
  const [filteredAsset, setFilteredAsset] = useState([]);

  const [empList, setEmpList] = useState([])
  const [item, setItem] = useState("");


  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [active, setActive] = useState("active");
  const [employee, setEmployee] = useState(emp_code || 'null');

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [buffer2, setBuffering2] = useState(true);
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);

  const [selectedDepartment, setSelectedDepartment] = useState('null');
  const [selectedDesignation, setDesignation] = useState('')
  const [quantity, setQuantity] = useState("");
  const [startdate, setStartDate] = useState('');
  const [enddate, setEndDate] = useState('');

  const getAsset = async () => {
    try {
      setBuffering(true); //buffering logic // Start Buffering
      // const res = await axios.get(`${BASE_URL}/wfm/assets/`);
      const res = await axios.get(`${BASE_URL}/wfm/assets-by-filters/${toggleCompany}/${selectedDepartment}/${active}/${employee}/`);
      setAssetname(res.data);
      setFilteredAsset(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };


  const getAllEmp_code = async () => {
    setBuffering1(true);
    try {
      const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetails/${active}/${toggleCompany}/`);
      const sortedList = customSortByKey(res.data, "emp_code");
      setEmpList(sortedList);
    } catch (err) {
      //toast Logic
      handleErrorToast(err)
    } finally {
      setBuffering1(false);// End Buffering
    }
  };

  const getDepartmentAndDesignation = async () => {
    setBuffering2(true);
    try {
      const des = await axios.get(
        `${BASE_URL}/wfm/designationfilterbysubcompanycount/${toggleCompany}/${active}/`
      );
      setDesignationList(des.data);

      const dep = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleCompany}/${active}/`
      );
      setDepartmentList(dep.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering2(false);// End Buffering
    }
  };

  useEffect(() => {
    getAsset();
    getAllEmp_code();
    getDepartmentAndDesignation();
  }, [active, employee, selectedDepartment, toggleCompany]);


  const handleSearch = () => {
    let filteredData = assetname;

    filteredData = filteredData.filter((i) => {
      const lowercaseItem = (item || '').toLowerCase();
      const lowercaseQuantity = String(quantity || '').toLowerCase();

      const itemMatch = (i.item || '').toLowerCase().includes(lowercaseItem);
      const descMatch = (i.description || '').toLowerCase().includes(lowercaseItem);
      const quantityMatch = String(i.quantity || '').toLowerCase().includes(lowercaseQuantity);

      if (item && quantity) {
        return (itemMatch || descMatch) && quantityMatch;
      }

      if (item) {
        return itemMatch || descMatch;
      }

      if (quantity) {
        return quantityMatch;
      }

      return true;
    });

    if (selectedDesignation) {
      filteredData = filteredData.filter((desig) => {
        return String(desig.designation_title) === selectedDesignation;
      });
    }
    if (startdate) {
      filteredData = filteredData.filter(
        (i) => i.date >= startdate
      );
    }
    if (enddate) {
      filteredData = filteredData.filter(
        (i) => i.date <= enddate
      );
    }

    setFilteredAsset(filteredData);
  };


  useEffect(() => {
    handleSearch();
  }, [
    assetname,
    item,
    quantity,
    selectedDesignation,
    startdate,
    enddate
  ]);

  const options = empList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOption = { value: 'null', label: 'Select Employee Code' };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setEmployee(selectedOption.value);
    } else {
      setEmployee('null');
    }
  };


  useEffect(() => {
    if (startdate === null && enddate === null) {
      setStartDate('');
      setEndDate('');
    }
  }, [startdate, enddate]);
  return (
    <>
      <ToastContainer position="top-center" autoClose={1} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <div className="content-tabs">
        <div className="field-parent-cont">
          <div className="field-cont">
            {SUPER_ADMIN &&
              <>
                <div className="field-cont-div">
                  <select
                    onChange={(e) => setToggleCompany(e.target.value)}
                    value={toggleCompany}
                    className="attendance-input-field width-10vw   date-field"
                  >
                    <option value="">Select Sub Company</option>
                    {SUB_COMPANIES.map(company => (
                      <option key={company.id} value={company.id}>
                        {company.title}
                      </option>
                    ))}
                  </select>
                  <hr className="field-cont-hr" />
                </div>
              </>
            }

            <div title=' Date Range' className="field-cont-div ">
              <DateRangePicker startDate={startdate} endDate={enddate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                setStartDate(start);
                setEndDate(end);
              }} />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <>
                {buffer1 ?
                  <div className="spinner-vsmall"></div>
                  :
                  <Employee />
                }
                <Select
                  className="attendance-input-field width-20vw"
                  options={[nullOption, ...options]}
                  value={options.find(option => option.value === employee) || nullOption}
                  placeholder="Select Employee Code"
                  onChange={handleChange}
                  isClearable
                  styles={CSSForDropdownFilter2}
                />
              </>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => {
                  setActive(e.target.value)
                }}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div-svg">
              <SearchBig />
              <input
                className="attendance-input-field width-16vw  "
                placeholder="By Item & Description"
                type="text"
                value={item}
                onChange={(e) => setItem(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer2 ?
                <div className="spinner-vsmall"></div>
                :
                <CircularGrid />
              }
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
              >
                <option value="">All Department</option>
                {departmentList
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ))};
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> :
                <CircularGrid />
              }
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDesignation}
                onChange={(e) => setDesignation(e.target.value)}
              >
                <option value="">All Designation</option>
                {designationList
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ))};
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div-svg">
              <SearchBig />
              <input
                className="attendance-input-field width-16vw  "
                placeholder="By Quantity"
                type="number"
                min={0}
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

          </div>
          <div className="btn-cont" style={{ minWidth: '130px' }}>
            <AssetModel getAsset={getAsset} employeeList={empList} />
          </div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">Asset</div>

          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">S.No.</th>
                <th className="align-left">Employee</th>
                <th className="align-left">Subcompany</th>
                <th className="align-left">Designation</th>
                <th className="align-left">Department</th>
                <th className="align-leftt">Name</th>
                <th className="align-center">Date</th>
                <th className="align-center">Item</th>
                <th className="align-center">Description</th>
                <th className="align-center">Quantity</th>

                <th className="align-right width-10vw">Action</th>
              </tr>
            </thead>
            {buffer ? <div className="spinner"></div> : //buffering logic
              <tbody>
                {filteredAsset.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      {/* <td className="align-leftt">{i.emp_code}</td> */}
                      <td className="align-center">

                        <CustomImageModal
                          customStyle>
                          {i.profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.profilepic}`}
                              alt="profile" className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo user={{ name: i.name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'profile-img'} />
                          )}
                        </CustomImageModal>
                        <p>{i.emp_code}- {i.name}</p>

                      </td>

                      <td className="align-leftt">{i.sub_company_title}</td>
                      <td className="align-leftt">{i.designation_title}</td>
                      <td className="align-leftt">{i.department_title}</td>
                      <td className="align-leftt">{i.name}</td>
                      <td className="align-center">{formatDate(i.date)}</td>
                      <td className="align-center">{i.item}</td>
                      <td className="align-center">{i.description}</td>
                      <td className="align-center">{i.quantity}</td>

                      <td className="align-right width-10vw ">
                        <AssetModelUpdate i={i} getAsset={getAsset} employeeList={empList} />
                        <AssetModelDelete i={i} getAsset={getAsset} />
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            }
          </table>
        </div>
      </div >
    </>
  );
};

// const EmployeeAssets = ({ email, emp_code }) => {
//   const { PERMISSION_HR_ADMIN, PERMISSION_AUTHORITY } = usePermission(); // Use the custom hook
//   const [assetname, setAssetname] = useState([]);
//   const [buffer, setBuffering] = useState(true); //buffering logic
//   const [searchQuery, setSearchQuery] = useState("");
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const getAsset = async () => {
//     setBuffering(true); // Start Buffering
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/wfm/asset-by-employee/${emp_code}/`
//       );
//       setAssetname(res.data);
//     } catch (err) {
//       //toast Logic
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false);// End Buffering
//     }
//   };

//   useEffect(() => {
//     getAsset();
//   }, []);

//   return (
//     <>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

//       <div className="table-css-white-background">
//         <div className="table-heading-flex">
//           <div className="repo-heading font-weight500    font-size-heading">Asset ({assetname.length})</div>
//           {assetname.length < 1 ? "No System Alloted" : ""}
//           <div>
//             <div className="table-searchh">
//               <div>
//                 <SearchBig />
//                 <input
//                   placeholder="Search Extension No."
//                   className="navbar-inputt font-weight400  font-size-text"
//                   value={searchQuery}
//                   min={0}
//                   onChange={handleSearchChange}
//                   type="number"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <table className="table-css">
//           <thead>
//             <tr className="custom-table-head-tr">
//               <th className="align-left">Sr. No.</th>
//               <th className="align-center">Date</th>
//               <th className="align-center">Description</th>
//               <th className="align-center">Quantity</th>
//               <th className="align-center">Item</th>
//             </tr>
//           </thead>
//           {buffer ? <div className="spinner"></div> :
//             <tbody>
//               {assetname
//                 ?.filter(
//                   (e) =>
//                     e.item.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
//                     e.description.toString().toLowerCase().includes(searchQuery.toLowerCase())
//                 ).map((i, index) => (
//                   <React.Fragment key={index}>
//                     <tr className="tr-border-bottom">
//                       <td colSpan="6"></td>
//                     </tr>
//                     <tr className="custom-table-head-td">
//                       <td className="align-left">{index + 1}</td>

//                       <td className="align-center">{i.date ? formattedDateLong(i.date) : '-'}</td>
//                       <td className="align-center">{i.description}</td>
//                       <td className="align-center">{i.quantity}</td>
//                       <td className="align-center">{i.item}</td>
//                     </tr>
//                   </React.Fragment>
//                 ))}
//             </tbody>}
//         </table>
//       </div>
//     </>
//   );
// };

const EmployeeAssets = ({ email, emp_code }) => {
  const { PERMISSION_HR_ADMIN, PERMISSION_AUTHORITY } = usePermission();
  const [assetname, setAssetname] = useState([]);
  const [buffer, setBuffering] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const getAsset = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/asset-by-employee/${emp_code}/`
      );
      setAssetname(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getAsset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredAssets = assetname?.filter(
    (e) =>
      e.item?.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
      e.description?.toString().toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <div className="table-css-white-background">
        
        {/* Responsive Header & Search Section */}
        <div className="table-heading-flex" style={{flexWrap: "wrap", gap: "15px", marginBottom: "20px", alignItems: "center", justifyContent: "space-between" }}>
          <div className="repo-heading font-weight500 font-size-heading" style={{ margin: 0 }}>
            Assets ({assetname.length})
          </div>
          
          <div className="field-cont" style={{gap: "10px",}}>
            <div className="table-searchh dropdown-container field-cont-div" style={{ margin: 0, padding: "5px 15px", borderRadius: "8px", background: "#f6f7f9", display: "flex", alignItems: "center", minWidth: "250px", flexWrap:"nowrap" }}>
              <SearchBig />
              <input
                placeholder="Search Item or Description..."
                className="navbar-inputt font-weight400 font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
                type="text"
                style={{ border: "none", background: "transparent", outline: "none", width: "100%", paddingLeft: "10px" }}
              />
            </div>
          </div>
        </div>

        {/* Responsive Table Section */}
        <div style={{ overflowX: "auto", width: "100%" }}>
          <table className="table-css" style={{ width: "100%", minWidth: "600px" }}>
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr. No.</th>
                <th className="align-center">Date</th>
                <th className="align-left">Description</th>
                <th className="align-center">Quantity</th>
                <th className="align-left">Item</th>
              </tr>
            </thead>
            
            {/* Valid HTML rendering for Body states */}
            <tbody>
              {buffer ? (
                <tr>
                  <td colSpan="5" style={{ padding: "40px 0", textAlign: "center" }}>
                    <div className="spinner" style={{ margin: "0 auto" }}></div>
                  </td>
                </tr>
              ) : filteredAssets.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ padding: "40px 0", textAlign: "center", color: "#6B7280" }}>
                    {assetname.length === 0 ? "No System Alloted" : "No matching assets found"}
                  </td>
                </tr>
              ) : (
                filteredAssets.map((i, index) => (
                  <tr key={index} className="custom-table-head-td" style={{ borderBottom: "1px solid #e8e8e8" }}>
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">{i.date ? formattedDateLong(i.date) : '-'}</td>
                    <td className="align-left">{i.description}</td>
                    <td className="align-center">{i.quantity}</td>
                    <td className="align-left">{i.item}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>
    </>
  );
};

export { AssetsManagement, EmployeeAssets };
